export const storeConfig = {
  devtools: process.env.NODE_ENV === 'development',
  middleware: [],
};
